/** @format */

import React from "react";
import LandingPage from "../../components/LandingPage";

export default function Konnect345() {
  return (
    <LandingPage
      type="with"
      iosUrl="https://iosStorage.com"
      androidUrl="https://androidStorage.com"
    />
  );
}
